/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_InvoicesInputs */



/**
* | output |
* | --- |
* | "No invoices found." |
*
* @param {No_InvoicesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const no_invoices = /** @type {((inputs?: No_InvoicesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_InvoicesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucune facture trouvée.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Es wurden keine Rechnungen gefunden.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessuna fattura trovata.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Счета-фактуры не найдены.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se encontraron facturas.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("未找到发票。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("請求書が見つかりません。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कोई बिल नहीं मिला।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nenhuma fatura encontrada.")
	return /** @type {LocalizedString} */ ("No invoices found.")
});